import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CurrencyConverter } from '@paladin-monorepo/common';
import { currencyApi } from '@/lib/api/currency';

export function useCurrencyRates() {
  const query = useQuery({
    queryKey: ['currency', 'rates'],
    queryFn: () => currencyApi.getRates(),
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 1,
  });

  const converter = useMemo(
    () => (query.data?.rates ? new CurrencyConverter(query.data.rates) : null),
    [query.data]
  );

  return {
    ...query,
    rates: query.data?.rates,
    baseCurrency: query.data?.baseCurrency,
    converter,
  };
}
